
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/billing",
      function () {
        return require("private-next-pages/profile/billing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/billing"])
      });
    }
  